// 同一款遊戲的其他版本（GDO-30）：卡片上的「N 個版本」與「豪華版提前遊玩」標示。
import { parseReleaseDate, type ReleaseDate, releaseSortKey } from '@dayone/core/release-date';
import type { IndexRow } from '@dayone/core/snapshot';
import type { CatalogItem } from '../../filters/catalog.ts';
import { t } from '../../i18n/zh-TW.ts';
import { formatRelease } from '../../lib/format.ts';
import { Hint } from '../../ui/Hint.tsx';
import { ICON, Layers, Zap } from '../../ui/icons/index.ts';

/** 版本名稱的中文（常見名稱），沒有對應時用原名 */
export function editionLabel(title: string): string {
  return t.editions.names[title.toLowerCase().replace(/[’']/g, "'")] ?? title;
}

const shortDate = (d: ReleaseDate) => (d.p === 'day' ? `${d.m}/${d.d}` : '');

/** 比基本版更早可以玩的版本（搶先遊玩）：還沒發售、兩者都是確定日期時才算 */
export function earlyEdition(item: Pick<CatalogItem, 'row' | 'date' | 'released'>) {
  if (item.released || item.date.p !== 'day' || !item.row.ed) return null;
  const main = releaseSortKey(item.date);
  let best: { title: string; date: ReleaseDate; days: number } | null = null;
  for (const [title, d] of item.row.ed) {
    const date = parseReleaseDate(d);
    if (date?.p !== 'day') continue;
    const days = main - releaseSortKey(date);
    if (days > 0 && (!best || days > best.days)) best = { title, date, days };
  }
  return best;
}

export function EditionsBadge({ row, currentYear }: { row: IndexRow; currentYear: number }) {
  if (!row.ed?.length) return null;
  const main = parseReleaseDate(row.d);
  const lines = [
    `${t.editions.standard} ${main ? formatRelease(main, currentYear) : row.d}`,
    ...row.ed.map(([title, d]) => {
      const date = parseReleaseDate(d);
      return `${editionLabel(title)} ${date ? formatRelease(date, currentYear) : d}`;
    }),
  ];
  return (
    <Hint content={t.editions.hint(lines)}>
      <button type="button" className="badge badge-editions">
        <Layers {...ICON} />
        {t.editions.count(row.ed.length + 1)}
      </button>
    </Hint>
  );
}

export function EarlyEditionChip({ item }: { item: CatalogItem }) {
  const early = earlyEdition(item);
  if (!early) return null;
  const label = editionLabel(early.title);
  return (
    <Hint content={t.editions.earlyHint(label, early.days)}>
      <button type="button" className="badge badge-accent badge-early">
        <Zap {...ICON} />
        {t.editions.early(label, shortDate(early.date))}
      </button>
    </Hint>
  );
}
